export const questionListCN = [
    {
        id: 0,
        question: "如何登入「电子表格递交系统」？",
        answer: [
            {
                number: 1,
                description: "「统一登入系统」(CLO) 登入方式：「统一登入系统」(CLO) 使用者有两种登入方式：",
                description0: "1. 透过",
                description6: "2. 直接透过「电子表格递交系统」(e-FormSS) ",
                description7: "登入",
                CLOEfomssHyperlink: "cloportallogin",
                SSLOEfomssHyperlink: "loginSSLO",
                PublicEfomssHyperlink: "loginPublic",
                link: "连结",
                clo: "「统一登入系统」",
                dot: "。",
                CLOHyperlink: "https://clo.edb.gov.hk",   
                description3: "SSLO登入方式：SSLO使用者可以直接使用「电子表格递交系统」(e-FormSS) ",
                description4: "公众登入方式：公众可直接使用「电子表格递交系统」(e-FormSS) ",
                description5:" 他们可以选择使用自己的电子邮件地址或「智方便」进行身份验证。 ",
                multiple : "3"
            }
        ]
    },


    {
        id: 1,
        question: "我应该使用哪种登入方法：统一登入系统(CLO)、SSLO，还是公众帐号？",
        answer: [
            {
                number: 1,
                description: "「统一登入系统」(CLO) 登入方式：适用于教师、校长和校监等。他们必须拥有「电子化服务入门网站」(e-Services) ，「统一登入系统」(CLO) 或「培训行事历系统」(TCS) 帐户才能登入。 ",
                description3: "SSLO 登入方式：拥有 SSLO 帐户的非政府组织。",
                description4: "公众登入方式: 供所有公众使用。",
                multiple : "3"
            }
        ]
    },

    {
        id: 2,
        question: "提交电子表格接受的附件的文件大小或文件类型有限制吗？",
        answer: [
            {
                number: 1,
                description: "有的，每张表格的要求可能会有所不同。请查看具体表格对应的说明。"
            }
        ]
    },

    {
        id: 3,
        question: "表格支援那些签署方式？",
        answer: [
            {
                number: 1,
                title: "目前支援三种签署方式：\n",
                description: "电子签署。",
                description3: "上传签署图像档案。（可接受的档案类型：jpg、jpeg、png；附件上限为 3MB，档案名称长度不得超过 70 个字元。）",
                description4: "「智方便+」。 （部份表格只接受此方式。）",
                multiple : "3",
            },
        ]
    },

    {
        id: 4,
        question: "为什么我看不到想要填写的表格？",
        answer: [
            {
                number: 1,
                description: "某些表格可能只开放予特定群组（公众登入/「统一登入系统」(CLO)/SSLO）。如果你不属于指定群组，你可能看不到该表格。你可以联络具有学校管理员/机构行政户口权限的使用者(例如校长、学校行政主户(MSA) 及「统一登入系统」学校行政户口(CSA)等)，前往「电子表格递交系统」的委派页面并将表格委派给你。 " }
        ]
    },

    {
        id: 5,
        question: "如果表格被拒绝，可以再次提交同一表格吗？",
        answer: [
            {
                number: 1,
                description: "不可以，被拒绝的表格不能再次提交。如果表格被拒绝，你只能使用新表格重新申请。不过，如果表格仅被其他单位退回，你可以进行编辑并再次提交表格。"
            }
        ]
    },
    
    {
        id: 6,
        question: "如何委派表格？",
        answer: [
            {
                number: 1,
                description: "委派权限仅适用于管理员、校长和校监。委派功能可以在「委派页面」下的功能表列中找到。 "
            }
        ]
    },

    {
        id: 7,
        question: "为什么我不能委派表格给我的同事？",
        answer: [
            {
                number: 1,
                description: "该表格可能仅限于特定职位，或者你的同事与你不属于同一学校或组织。"
            }
        ]
    },

    {
        id: 8,
        question: "我如何查阅表格的申请状态？",
        answer: [
            {
                number: 1,
                description: "登录「电子表格递交系统」并点选「表格查询」。 "
            }
        ]
    },

    {
        id: 9,
        question: "如何查询表格参考编号？",
        answer: [
            {
                number: 1,
                description: "表格参考编号显示在通知电子邮件中，也可以在「电子表格递交系统」的「表格查询」中找到。 "
            }
        ]
    },

    {
        id: 10,
        question: "我在学校任职，但为什么我无法在「电子表格递交系统」中更新个人资料？",
        answer: [
            {
                number: 1,
                description: "「电子表格递交系统」内有关用户的个人资料由「电子化服务入门网站」 (e-Services)、「统一登入系统」 (CLO)或「培训行事历系统」 (TCS) 提供。用户需登入以上有关网站/系统以更新个人资料。 "
            }
        ]
    },

    {
        id: 11,
        question: "为什么学校的学校行政主户 (MSAs) 和「统一登入系统」学校行政户口 (CSAs)在职员管理中无法新增、编辑或删除职员资料？",
        answer: [
            {
                number: 1,
                description: "职员资料由「电子化服务入门网站」(e-Services)、「统一登入系统」(CLO) 或「培训行事历系统」(TCS) 提供。用户需登入以上有关网站/系统以更新有关资料。 "
            }
        ]
    },

    {
        id: 12,
        question: "公众/机构用户如何在「电子表格递交系统」中更新个人资料？",
        answer: [
            {
                number: 1,
                description: "登入「电子表格递交系统」后，在「个人资料」中更新。 "
            }
        ]
    },

    {
        id: 13,
        question: "机构如何删除现有行政户口？",
        answer: [
            {
                number: 1,
                description: "机构必需有多于一个行政户口时，才能删除其他的行政户口。"
            }
        ]
    },

    {
        id: 14,
        question: "如何一次过修改所有表格的预设申请人或审批人？",
        answer: [
            {
                number: 1,
                description: "目前系统不支援该功能。使用者需要分别为每张表格选择申请人或审批人。"
            }
        ]
    },

    {
        id: 15,
        question: "申请人提交表格后，为什么审批人没有收到该表格？",
        answer: [
            {
                number: 1,
                description: "当指定人委派表格时，审批人的帐户应与指定人选择的帐户相符。例如，审批人通常是校长的个人帐户，那校长应以个人帐户登入系统，才会收到该表格。 "
            }
        ]
    },

    {
        id: 16,
        question: "如果我对填写表格有疑问该怎么办？",
        answer: [
            {
                number: 1,
                description: "用户可前往「电子表格递交系统」主页左侧，选择「电子表格」，然后填写表格名称。点击表格名称右侧的",
                imageSrc: "1",
                description2:"图示查看与表格相关的查询电话号码以获得协助。"
            }
        ]
    },

    {
        id: 17,
        question: "为什么委派时找不到审批人帐号？",
        answer: [
            {
                number: 1,
                description: "如果是在「电子化服务入门网站」(e-Services)，「统一登入系统」(CLO) 或「培训行事历系统」(TCS)建立的新帐户，指定人可能找不到申请人或审批人的帐户。在这种情况下，指定人需要等待1-2天才能成功委派该申请人或审批人。 "
            }
        ]
    },
    {
        id: 18,
        question: "可以一次过更改所有已递交表格的审批人吗？",
        answer: [
            {
                number: 1,
                description: "不可以。学校行政主户 (MSAs)、「统一登入系统」学校行政户口 (CSAs)、校监、校长或机构负责人必须在委派页面内逐一更改每张表格。原来的审批人亦可于表格内将表格委派给新的审批人。 "
            }
        ]
    },
    {
        id: 19,
        question: "为什么我在委派页面找不到要委派的表格？",
        answer: [
            {
                number: 1,
                description: "如果委派页面上不存在该表格，请联络「电子表格递交系统」支援热线寻求进一步协助。 "
            }
        ]
    },
    {
        id: 20,
        question: "如果我提交了错误的表格该怎么办？",
        answer: [
            {
                number: 1,
                description: "请参阅申请/表格的资料并联络教育局相关的部门以获得协助。"
            }
        ]
    },
    
];
